import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cv_user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('cv_token');
    if (token) {
      auth.me().then(r => { setUser(r.data); setLoading(false); })
        .catch(() => { localStorage.clear(); setUser(null); setLoading(false); });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await auth.login(email, password);
    localStorage.setItem('cv_token', data.token);
    localStorage.setItem('cv_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('cv_token');
    localStorage.removeItem('cv_user');
    // The Ask thread pointer belongs to whoever just left. Hygiene, NOT isolation:
    // the server refuses another user's conversation_id (chat.js filters every
    // query by req.user.id) and AskPage clears a stale value on mount. It is
    // cleared here because a pointer to the previous person's thread should not
    // sit in the next person's browser at all, even inert.
    localStorage.removeItem('cv_conversation_id');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
